import * as React from 'react';
import { cn } from '@/lib/utils';

export type BuilderVariant =
  | 'reading-notebook'
  | 'aha'
  | 'writing-notebook'
  | 'hands-on-hips';

const SRC: Record<BuilderVariant, string> = {
  'reading-notebook': '/character-system/poses/builder-04-reading-notebook-v1.png',
  'aha':              '/character-system/poses/builder-04-aha-v1.png',
  'writing-notebook': '/character-system/poses/builder-04-writing-notebook-v1.png',
  'hands-on-hips':    '/character-system/poses/builder-04-hands-on-hips-v1.png',
};

const ALT: Record<BuilderVariant, string> = {
  'reading-notebook': 'The Builder reading a notebook',
  'aha':              'The Builder having an aha moment',
  'writing-notebook': 'The Builder writing in a notebook',
  'hands-on-hips':    'The Builder reviewing with hands on hips',
};

export interface BuilderProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  variant: BuilderVariant;
  alt?: string;
}

/**
 * The Builder — the customer / the coach who's building. Race bib 04, coral accent.
 * Locked PNG poses live at /character-system/poses/.
 */
export const Builder = React.forwardRef<HTMLImageElement, BuilderProps>(
  ({ variant, alt, className, ...rest }, ref) => (
    <img
      ref={ref}
      src={SRC[variant]}
      alt={alt ?? ALT[variant]}
      className={cn('block select-none', className)}
      draggable={false}
      {...rest}
    />
  ),
);
Builder.displayName = 'Builder';
